// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogEntry_container__DF7wf","blogHead":"BlogEntry_blogHead__LXo3Q","blogBody":"BlogEntry_blogBody__ITKTQ","moreBlogs":"BlogEntry_moreBlogs__D0YQO"};